module["exports"] = [
  "град"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/uk/address/city_suffix.js
 ** module id = 1121
 ** module chunks = 0
 **/